import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'prizeWall', en);
i18next.addResources('fr', 'prizeWall', fr);

declare global {
  interface RegisteredLocales {
    prizeWall: typeof en;
  }
}
